import dayjs from 'dayjs';
import { USERSROLE } from 'types';

export const filterStr = ({ formData }: any) => {
  const filteredString = Object.entries(formData).reduce(
    (accumulator: any, currentValue: any) => {
      switch (currentValue[0]) {
        case 'email':
          return `${accumulator},email:%${currentValue[1]}%`;
        case 'firstName': {
          return `${accumulator},firstName:%${currentValue[1]}%`;
        }
        case 'lastName': {
          return `${accumulator},lastName:%${currentValue[1]}%`;
        }
        case 'phone': {
          return `${accumulator},phoneNumber:${currentValue[1]}`;
        }
        case 'role': {
          return `${accumulator},role:${currentValue[1]}`;
        }
        case 'organisation': {
          return `${accumulator},organisation:${currentValue[1]}`;
        }
        case 'utilityId': {
          return `${accumulator},utilityId:${currentValue[1]}`;
        }
        case 'lastLogin': {
          return `${accumulator},lastLoggedInAfter:${currentValue[1]}`;
        }
        default:
          return accumulator;
      }
    },
    ''
  );
  return filteredString.substring(1);
};

export const filterStringReducer = (accumulator: any, currentValue: any) => {
  const [key, value] = currentValue;

  switch (key) {
    case 'email':
      accumulator = value ? { ...accumulator, email: value } : accumulator;
      break;
    case 'firstName':
      accumulator = value ? { ...accumulator, firstName: value } : accumulator;
      break;
    case 'lastName':
      accumulator = value ? { ...accumulator, lastName: value } : accumulator;
      break;
    case 'phone':
      accumulator = value ? { ...accumulator, phone: value } : accumulator;
      break;
    case 'organisation':
      accumulator = value
        ? { ...accumulator, organisation: value }
        : accumulator;
      break;
    case 'utilityId':
      accumulator = value ? { ...accumulator, utilityId: value } : accumulator;
      break;
    case 'role':
      accumulator =
        value && value.id !== '0'
          ? {
              ...accumulator,
              role:
                value.text === 'BYDAADMIN' ? USERSROLE.DBYDADMIN : value.text
            }
          : accumulator;
      break;
    case 'lastLogin': {
      let dateObj;
      switch (value.text) {
        case 'Today':
          dateObj = dayjs().startOf('day').toISOString();
          break;
        case 'Last 15 minutes':
          dateObj = dayjs().subtract(15, 'minute').toISOString();
          break;
        case 'Last hour':
          dateObj = dayjs().subtract(60, 'minute').toISOString();
          break;
        case 'Last 7 days':
          dateObj = dayjs().subtract(7, 'day').toISOString();
          break;
        case 'all':
          dateObj = null;
          break;
        default:
          dateObj = null;
      }
      accumulator =
        dateObj !== null ? { ...accumulator, lastLogin: dateObj } : accumulator;
      break;
    }
  }
  return accumulator;
};

export const isShowButton = (errors: any): boolean => {
  return (
    !errors.email &&
    !errors.firstName &&
    !errors.lastName &&
    !errors.phone &&
    !errors.lastLogin
  );
};
